<script setup lang="ts">
import { createOrUpdateStripeAccount } from '@/api/stripe'

interface IEmits {
  (event: 'updateProcessing', e: boolean): void
}

const emit = defineEmits<IEmits>()
const { colors } = useTheme()

const userStripeAccount = useUserStripeAccount()

async function handleAccountClick() {
  emit('updateProcessing', true)
  const updateUrl = await createOrUpdateStripeAccount()

  if (updateUrl) {
    userStripeAccount.value = { state: 'restricted', ratio: 0.8 }
    window.location.href = updateUrl
  }
  emit('updateProcessing', false)
}
</script>

<template>
  <div flex items-center cursor-pointer h-min @click="handleAccountClick">
    <Text :color="colors.orange" variant="caption" bold>
      Complete seller profile
    </Text>
    <div i-iconoir-arrow-tr text-orange ml-1 w="12px" h="12px" />
  </div>
</template>
